import TreatmentStatus from "./components/TreatmentStatus";
import FieldInfo from "../../../components/FieldInfo";
import getUpdatedString from "../../../components/utils/getUpdatedString";
import DocumentStatus from "./components/DocumentStatus";
import { useProCliStore } from "../../../hooks/useProCliStore";

export default function Status({
  currentAccordionItem,
  activateButtons,
  deactivateButtons,
}) {
  const {setProvidersData} = useProCliStore();
  const index = currentAccordionItem.index;
  const proCliData = currentAccordionItem.proCliData;

  const updateProviderInfo = (updatedData = null) => {
    if (!updatedData) {
      deactivateButtons();
      return;
    }
    if (updatedData.get(index).editableFields === null) {
      deactivateButtons();
    } else {
      activateButtons();
    }
    if (updatedData !== null) {
      setProvidersData(updatedData);
    }
  };

  return (
    <div id="Provider-Statuses" data-testid="Provider-Statuses">
      <div className="flex flex-row justify-start w-full mt-4 flex-wrap">
        <div className="w-1/2 flex flex-row justify-start p-0 m-0">
          <div>
            <TreatmentStatus
              canEdit={proCliData?.canEdit}
              title={"Treatment"}
              index={index}
              fieldName={"treatmentStatus"}
              initialValue={proCliData?.finishedTreatment}
              updateProviderInfo={updateProviderInfo}
            />
            <FieldInfo
              title={"Updated"}
              value={getUpdatedString(
                proCliData?.treatmentStatusChangedByName,
                proCliData?.treatmentStatusChanged
              )}
            />
          </div>
        </div>

        <div className="w-1/2 flex flex-row justify-start p-0 m-0">
          <div>
            <DocumentStatus
              canEdit={proCliData?.canEdit}
              title={"Document"}
              fieldName={"documentStatus"}
              index={index}
              initialValue={proCliData?.medicalDocumentsStatus}
              updateProviderInfo={updateProviderInfo}
            />
            <FieldInfo
              title={"Updated"}
              value={getUpdatedString(
                proCliData?.documentStatusChangedByName,
                proCliData?.documentStatusChanged
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
